import { render, staticRenderFns } from "./PortalResponsibility.vue?vue&type=template&id=dd2733fe&scoped=true"
import script from "./PortalResponsibility.vue?vue&type=script&lang=js"
export * from "./PortalResponsibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2733fe",
  null
  
)

export default component.exports